export type TransitionMap<TState extends number | string> =
  Partial<Record<TState, readonly TState[]>>;

export type AllowedActionsMap<TState extends number | string, TAction extends string> =
  Partial<Record<TState, readonly TAction[]>>;

export interface StateMachineConfig<
  TState extends number | string,
  TAction extends string
> {
  transitions: TransitionMap<TState>;
  allowedActions: AllowedActionsMap<TState, TAction>;
}

export class StateMachine<
  TState extends number | string,
  TAction extends string
> {
  constructor(private cfg: StateMachineConfig<TState, TAction>) {}

  canTransition(from: TState, to: TState): boolean {
    const next = this.cfg.transitions[from] ?? [];
    return next.includes(to);
  }

  can(action: TAction, state: TState): boolean {
    return (this.cfg.allowedActions[state] ?? []).includes(action);
  }
}